module.exports = __webpack_public_path__ + "img/album-collection.1b0f7283.svg";